import './videoTelematicsFilter.css';
import Checkbox from "../../../shared/checkbox/checkbox";
import VehicleFilters from "../../filtersComponents/vehicleFilters/vehicleFilters";
import GroupFilters from "../../filtersComponents/groupFilters/groupFilters";
import {useSelector} from "react-redux";
import {
    telematicsVehicleFilter,
    telematicsGroupFilter,
    telematicsAlertFilter
} from "../../../store/slicers/videoTelematicsFilterSlicer";
import AlertsFilter from "../../filtersComponents/alertsFilter/alertsFilter";

const VideoTelematicsFilter = () => {
    const telematicsFilter = useSelector(state => state.telematicsFilter);

    return(
        <ul className={'filter-list round-corner-8 disabled'}>
            <li>
                <div className="filter-title">Category</div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Road Alerts</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Cabin Alerts</label>
                </div>
            </li>
            <li>
               <GroupFilters filter={telematicsFilter}
                             dispatcher={telematicsGroupFilter}/>
                {/*<div className="dark-grey-color flex">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'margin-l-10'}>Group 1</label>*/}
                {/*</div>*/}
                {/*<div className="dark-grey-color flex">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'margin-l-10'}>Group 2</label>*/}
                {/*</div>*/}
                {/*<div className="dark-grey-color flex">*/}
                {/*    <Checkbox checked={false}/>*/}
                {/*    <label className={'margin-l-10'}>Group 3</label>*/}
                {/*</div>*/}
                {/*<div className="dark-grey-color flex">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'margin-l-10'}>Group 4</label>*/}
                {/*</div>*/}
            </li>
            <li>
                <VehicleFilters filter={telematicsFilter}
                                dispatcher={telematicsVehicleFilter}/>
                {/*<div className="dark-grey-color flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'margin-l-10'}>KA 05 HJ 1890</label>*/}
                {/*</div>*/}
                {/*<div className="dark-grey-color flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'margin-l-10'}>KA 06 HJ 1360</label>*/}
                {/*</div>*/}
                {/*<div className="dark-grey-color flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'margin-l-10'}>KA 07 HJ 2890</label>*/}
                {/*</div>*/}
                {/*<div className="dark-grey-color flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'margin-l-10'}>KA 02 HJ 7830</label>*/}
                {/*</div>*/}
                {/*<div className="dark-grey-color flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'margin-l-10'}>KA 05 HJ 1890</label>*/}
                {/*</div>*/}
            </li>
            <li>
                <AlertsFilter filter={telematicsFilter}
                              dispatcher={telematicsAlertFilter}/>
            </li>
            <li>
                <div className="filter-title">Show Alert</div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>All</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox />
                    <label className={'margin-l-10'}>With Video</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox/>
                    <label className={'margin-l-10'}>Without Video</label>
                </div>
            </li>
            {/*<li>*/}
            {/*    <div className="filter-title">Location (State)</div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>AP</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Assam</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Chandigharh</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Delhi</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Gujarat</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Karnataka</label>*/}
            {/*    </div>*/}
            {/*</li>*/}
        </ul>
    )
}

export default VideoTelematicsFilter;
